import { render, staticRenderFns } from "./BaseItem.vue?vue&type=template&id=a1a39ddc&"
import script from "./BaseItem.vue?vue&type=script&lang=js&"
export * from "./BaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1a39ddc')) {
      api.createRecord('a1a39ddc', component.options)
    } else {
      api.reload('a1a39ddc', component.options)
    }
    module.hot.accept("./BaseItem.vue?vue&type=template&id=a1a39ddc&", function () {
      api.rerender('a1a39ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/nav-menu-items/BaseItem.vue"
export default component.exports